export enum SelectedNotesTab {
    Notes = 'notes',
    Clinical = 'clinical'
}